import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {connect} from 'react-redux'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Autocomplete from 'components/Autocomplete'
import {getLookupOptions} from 'utils/utils'
import {fieldtype} from 'utils/enums/fieldtype'

const Control = styled(FormControl)`
	width: 100%;
	margin-bottom: 20px;
`

function isCustomTemplate(template, entity) {
    let tpl = `${template}`
    if (template && entity) {
        let count = 0
        entity.fields.forEach(field => {
            const value = `<%= c${field.fieldId} %>`
            if (tpl.indexOf(value) > -1) {
                tpl = tpl.replace(value, '')
                count++;
            }
        })
        return count !== 1 || !!tpl
    }
    return false
}

function decodeTemplate(template, entity) {
    if (template && entity) {
        let tpl = `${template}`
        entity.fields.forEach(field => {
            tpl = tpl.replace(new RegExp(`<%= c${field.fieldId} %>`, 'g'), `@${field.name}`)
        })
        return tpl;
    }
    return ''
}

function encodeTemplate(template, entity) {
    if (template && entity) {
        const fields = [...entity.fields].sort((a, b) => a.name.length > b.name.length ? -1 : 1)
        fields.forEach(field => {
            template = template.replace(new RegExp(`@${field.name}`, 'g'), `<%= c${field.fieldId} %>`)
        })
        return template.trim()
    }
    return ''
}

class LookupFieldConfig extends React.Component {
    constructor(props) {
        super(props)

        this.options = getLookupOptions(props.fieldId)

        const relation = props.relation ? props.relation : this.options.length ? this.options[0].id : ''
        const entity = this.options.find(e => e.id === relation)
        const fields = this.getRelationFields(relation)

        this.state = {
            custom: isCustomTemplate(props.linkedTemplate, entity),
            field: props.foreignerFcn ? props.foreignerFcn : this.options.length ? this.options[0].fields[0].fieldId : '',
            relation,
            template: decodeTemplate(props.linkedTemplate, entity),
            relationFields: fields
        }
    }

    handleChange = (event) => {
        if (event.target.name === 'relation') {
            const option = this.options.find(item => item.id === event.target.value)
            const fields = this.getRelationFields(option.id)

            this.setState({
                field: option.fields[0].fieldId,
                template: '',
                relationFields: fields
            })
        }

        this.setState({
            [event.target.name]: event.target.value
        })
    }

    changeType = () => {
        let template = this.state.template
        const option = this.options.find(e => e.id === this.state.relation)

        if (this.state.custom) {
            template = encodeTemplate(template, option)
        }

        this.props.changeTypeToLookup(this.state.custom ?
            {pointerId: option.path, linkedTemplate: template} :
            {pointerId: option.path, fieldId: this.state.field})

        this.props.onClose()
        this.props.handleCloseMenu()
    }

    getRelationFields = (relationId) => {
        if (relationId) {
            const relation = this.options.find(option => option.id === relationId)
            const fields = relation.fields.map(field => { return { id: field.fieldId, name: field.name } })

            return fields
        }
    }

    getOptions = () => {
        const fields = this.state.relationFields.map(field => field.name)
        const options = fields.filter((value, index, self) => self.indexOf(value) === index)

        return options
    }

    render() {
        const {intl} = this.props
        const hasLinkedField = this.props.entities.find(entity => entity.id === this.props.entity).fields.find(item => item.uiType === fieldtype.linkedfield && item.id !== this.props.fieldId)

        return (
            <React.Fragment>
                <DialogTitle>
                    {this.props.relation ? intl.formatMessage({id: "config.lookup_field_update_title"}) : intl.formatMessage({id: "config.lookup_field_create_title"})}
                </DialogTitle>
                <DialogContent sx={{overflowY: 'visible'}}>
                    {hasLinkedField ?
                        <React.Fragment>
                            <Control variant="standard">
                                <InputLabel shrink={true}>
                                    {intl.formatMessage({id: "config.lookup_field_label_to"})}
                                </InputLabel>
                                <Select
                                    value={this.state.relation}
                                    onChange={this.handleChange}
                                    inputProps={{
                                        name: 'relation'
                                    }}
                                >
                                    {this.options.map((item, index) =>
                                        <MenuItem key={index} value={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    )}
                                </Select>
                            </Control>
                            {!this.state.custom &&
                                <Control variant="standard">
                                    <InputLabel>{intl.formatMessage({id: "config.linked_field_label_to_field"})}</InputLabel>
                                    <Select
                                        value={this.state.field}
                                        onChange={this.handleChange}
                                        inputProps={{
                                            name: 'field'
                                        }}
                                    >
                                        {this.state.relationFields.map((item, index) =>
                                            <MenuItem key={index} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        )}
                                    </Select>
                                </Control>
                            }
                            {this.state.custom &&
                                <Autocomplete
                                    value={this.state.template}
                                    label='Lookup Field Template'
                                    onChange={(value) => this.setState({template: value})}
                                    options={this.getOptions()}
                                    component='input'
									style={{marginBottom: '20px'}}
                                />
                            }
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.custom}
                                        onChange={(e) => this.setState({ custom: e.target.checked })}
                                    />
                                }
                                label={intl.formatMessage({id: "config.use_custom_template"})}
                            />
                        </React.Fragment>
                    :
                        <div>
                            {intl.formatMessage({id: "config.lookup_field_error"})}
                        </div>
                    }
                </DialogContent>
                {hasLinkedField ?
                    <DialogActions>
                        <Button onClick={this.props.onClose} color="primary">
                            {intl.formatMessage({id: "app.confirm_cancel"})}
                        </Button>
                        <Button disabled={this.state.custom && !this.state.template} onClick={this.changeType} color="primary" variant="contained">
                            {intl.formatMessage({id: "app.confirm_save"})}
                        </Button>
                    </DialogActions> :
                    <DialogActions>
                        <Button onClick={this.props.onClose} color="primary">
                            {intl.formatMessage({id: "table.confirm_close"})}
                        </Button>
                    </DialogActions>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({entities}) => ({
    entities: entities.entities
})

export default connect(mapStateToProps)(injectIntl(LookupFieldConfig))
